const prettyPrintKey = (key) => {

  let name = key;
  name = name.replaceAll('-', ' ');
  name = name.replaceAll('_', ' ');
  name = name.replaceAll('__', ' ');
  name = name.replaceAll('--', ' ');
  name = name[0].toUpperCase() + name.slice(1);;

  return name;

};

export default prettyPrintKey;